import React from "react";

import Button from "../form/Button";
import Input from "../form/Input";
import IconButton from "material-ui/IconButton";
import { Select } from "../form/Select";
import DateTime from "../form/DateTime";
import { mpartial } from "../../utils";
import Add from "material-ui/svg-icons/content/add";
import Clear from "material-ui/svg-icons/content/clear";

import { ColumnType, filterTranslations, filterOperations } from "./constants";
import { FilterOperation } from "./dataProvider";
import {Refresh} from "@mui/icons-material";
import {ExportButton} from "./exportGrid";

const styles = {
  column: {
    marginRight: "10px",
    verticalAlign: "bottom",
  },
  operation: {
    marginRight: "10px",
    verticalAlign: "bottom",
  },
  selectValue: {
    marginRight: "20px",
    verticalAlign: "bottom",
    display: "inline-block",
  },
  value: {
    marginRight: "20px",
    marginTop: "15px",
    verticalAlign: "baseline",
    display: "inline-block",
  },
  filterAdd: {
    // marginLeft: 'auto',
  },
};

const getDefaultOperation = (column) => {
  if (column && column.filterItems) return FilterOperation.EQ;
  if (column && (column.filterBy ? column.filterBy.type : column.type) === ColumnType.TEXT)
    return FilterOperation.CONTAINS;
  if (column && (column.filterBy ? column.filterBy.type : column.type) === ColumnType.YESNO)
    return FilterOperation.EQ;
  if (column && column.fromDate) return FilterOperation.GTE;
  if (column && column.toDate) return FilterOperation.LTE;
  return null;
};

export default class Filters extends React.Component {
  handleFilterValueEdit = (filter, value) => {
    const { onFilterEdit } = this.props;

    const newFilter = {
      ...filter,
      value
    };

    onFilterEdit(filter, newFilter);
  };

  handleFilterValueEditDate = (filter, value) => {
    const { onFilterEdit } = this.props;

    const newFilter = {
      ...filter,
      value: value.substring(0, 10),
      isDate: true
    };

    onFilterEdit(filter, newFilter);
  };

  handleFilterOperationEdit = (filter, operation) => {
    const { onFilterEdit } = this.props;

    const newFilter = {
      ...filter,
      operation,
    };

    onFilterEdit(filter, newFilter);
  };

  handleFilterColumnEdit = (filter, field) => {
    const { onFilterEdit, columns } = this.props;

    const column = columns.find((c) => c.field === field);
    const defaultOperation = getDefaultOperation(column);

    const newFilter = {
      ...filter,
      field: field,
      displayField: column.displayField,
      filterBy: column.filterBy,
      operation: defaultOperation,
      value: "",
    };

    onFilterEdit(filter, newFilter);
  };

  onKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.handleLoad();
    }
  };

  handleLoad = () => {
    this.props.onPageChange(0);
  };

  handleReset = () => {
    let { filters, onFilterEdit } = this.props;

    filters.map((filter) => {
      let newOperation = null;

      switch (filter.operation) {
        case FilterOperation.CONTAINS:
          newOperation = FilterOperation.CONTAINS;
          break;
        case FilterOperation.GTE:
          newOperation = FilterOperation.GTE;
          break;
        case FilterOperation.LTE:
          newOperation = FilterOperation.LTE;
          break;
        default:
          newOperation = null;
      }
      const newFilter = {
        ...filter,
        field: filter.field,
        operation: newOperation,
        value: "",
      };
      return onFilterEdit(filter, newFilter);
    });

    this.props.onPageChange(0);
  };

  renderFilterValue = (column, value, filter) => {
    const label = "Hodnota";
    const type = column ? (column.filterBy ? column.filterBy.type : column.type) : null;

    if (column && column.filterItems) {
      return (
        <Select
          style={styles.selectValue}
          items={column.filterItems}
          label={label}
          value={value}
          onChange={mpartial(this.handleFilterValueEdit, filter,)}
        />
      );
    }

    switch (type) {
      case ColumnType.NUMBER:
        return (
          <Input
            style={styles.value}
            label={label}
            input={{
              value,
              onChange: mpartial(this.handleFilterValueEdit, filter),
              onKeyDown: this.onKeyDown,
              name: "number",
            }}
            type="number"
            inputProps={{ 'aria-label': 'Hodnota' }}
          />
        );
      case ColumnType.ENUM:
      case ColumnType.TEXT:
        return (
          <Input
            style={styles.value}
            label={label}
            input={{
              value,
              onChange: mpartial(this.handleFilterValueEdit, filter),
              onKeyDown: this.onKeyDown,
              name: "text"
            }}
            inputProps={{ 'aria-label': 'Hodnota'}}
          />
        );
      case ColumnType.DATE:
        return (
          <DateTime
            style={styles.value}
            meta={{ touched: false }}
            input={{
              onChange: mpartial(this.handleFilterValueEditDate, filter),
              onKeyDown: this.onKeyDown,
              value,
              name: "datepicker",
            }}
            inputProps={{ 'aria-label': 'Hodnota'}}
          />
        );
      case ColumnType.DATETIME:
        return (
          <DateTime
            style={styles.value}
            meta={{ touched: false }}
            input={{
              onChange: mpartial(this.handleFilterValueEdit, filter),
              onKeyDown: this.onKeyDown,
              value,
              name: "datetimepicker",
            }}
            dateOnly={false}
            useISO
          />
        );
      case ColumnType.DATETIMEWITHOUTZONE:
        return (
          <DateTime
            style={styles.value}
            meta={{ touched: false }}
            input={{
              onChange: mpartial(this.handleFilterValueEdit, filter),
              onKeyDown: this.onKeyDown,
              value,
              name: "datetimepicker",
            }}
            dateOnly={false}
          />
        );
      case ColumnType.CHECK:
        return (
          <Select
            style={styles.selectValue}
            items={[
              { id: "true", label: "Zaškrtnuto" },
              { id: "false", label: "Nezaškrtnuto" },
            ]}
            label={label}
            value={value}
            onChange={mpartial(this.handleFilterValueEdit, filter)}
          />
        );
      case ColumnType.YESNO:
        return (
          <Select
            style={styles.selectValue}
            items={[
              { id: "true", label: "ANO" },
              { id: "false", label: "NE" },
            ]}
            label={label}
            value={value}
            onChange={mpartial(this.handleFilterValueEdit, filter)}
          />
        );
      /*case ColumnType.ENUM:
        return (
          <Select
            style={styles.selectValue}
            items={column.enum}
            label={label}
            value={value}
            onChange={mpartial(this.handleFilterValueEdit, filter)}
          />
        );*/
      default:
        return (
          <Input
            style={styles.value}
            label={label}
            value=""
            disabled
            input={{}}
            name="filter"
          />
        );
    }
  };

  renderFilterRow = (filter, i) => {
    const { field, operation, value } = filter;
    const { columns, onFilterRemove, onFilterResetValue } = this.props;
    const column = columns.find((c) => c.field === field);

    const allowedOperations = column ? filterOperations[column.filterBy ? column.filterBy.type : column.type] : [];

    const filterObjects = allowedOperations.map((op) => ({
      id: op,
      label: filterTranslations[op],
    }));
    return (
      <li key={i} className="filters__row">
        <Select
          style={styles.column}
          label="Sloupec"
          valueField="field"
          items={columns.filter(
            (c) =>
              (c.filterable === true || c.sortable === true) &&
                (c.type !== ColumnType.JSX || !!c.filterBy),
          )}
          value={field}
          onChange={mpartial(this.handleFilterColumnEdit, filter)}
        />
        {getDefaultOperation(column) === null && (
          <Select
            style={styles.operation}
            label="Operace"
            items={filterObjects}
            value={operation}
            onChange={mpartial(this.handleFilterOperationEdit, filter)}
            disabled={getDefaultOperation(column) !== null}
          />
        )}
        {this.renderFilterValue(column, value, filter)}
        <div className="filters__clear">
          <IconButton
              className="filters__clearBtn"
              onTouchTap={mpartial(onFilterResetValue, filter)}
              aria-label="Vyčistit filtr"
          >
            <Refresh />
          </IconButton>
          <IconButton
            className="filters__clearBtn"
            onTouchTap={mpartial(onFilterRemove, filter)}
            aria-label="Odebrat filtr"
          >
            <Clear />
          </IconButton>
        </div>
      </li>
    );
  };

  render() {
    const { filters, onFilterAdd, addButtonStyle } = this.props;

    return (
      <div className="filters" onKeyDown={this.onKeyDown}>
        <div className="filters__list">
          <ul>{filters.map((filter, i) => this.renderFilterRow(filter, i))}</ul>
        </div>

        <div className="filters__actions">
          <div className="filters__actionsLeft">
            <IconButton
              style={styles.filterAdd}
              className="filters__add filterAddButton"
              onTouchTap={onFilterAdd}
              aria-label="Přidat filtr"
            >
              <Add />
            </IconButton>
          </div>

          <div className="filters__actionsRight">
            <Button
              className="primary"
              onTouchTap={this.handleLoad}
              style={{ ...addButtonStyle, minWidth: 150 }}
            >
              Aplikovat filtry
            </Button>
            <Button
              className="primary"
              onTouchTap={this.handleReset}
              style={{ ...addButtonStyle, minWidth: 150 }}
            >
              Resetovat filtry
            </Button>
            {this.props.exportPosition === 'FILTER' &&
                <ExportButton
                    url={this.props.url}
                    columns={this.props.columns}
                    gridName={this.props.gridName}
                    exportFileName={this.props.exportFileName}
                />
            }
          </div>
        </div>
      </div>
    );
  }
}
